import axios from './axiosConfig';
import { addIPInterceptor } from './ipHelper';

// 配置 axios 實例，用於設置基礎 URL
const api = axios.create({
  baseURL: process.env.REACT_APP_SITE_URL ? `${process.env.REACT_APP_SITE_URL}/api` : 'https://twrc.li.com.tw/api', // 替換為您後端的 API 基礎 URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// 添加 IP 攔截器以在請求中包含真實 IP
addIPInterceptor(api);

// 獲取特定權限
export const getPermission = async (permissionName, token) => {
  try {
    const response = await api.get(`/permissions/${permissionName}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching permission:', error);
    throw error;
  }
};

// 新增權限
export const addPermission = async (permissionData, token) => {
  try {
    const response = await api.post('/permissions', permissionData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error adding permission:', error);
    throw error;
  }
};

// 更新權限
export const updatePermission = async (permissionId, permissionData, token) => {
  try {
    const response = await api.put(`/permissions/${permissionId}`, permissionData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating permission:', error);
    throw error;
  }
};

// 刪除權限
export const deletePermission = async (permissionId, token) => {
  try {
    const response = await api.delete(`/permissions/${permissionId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.error('Error deleting permission:', error);
    throw error;
  }
};

// 導出預設的 axios instance
export default api;
